import { CanMatchFn, Route, UrlSegment } from "@angular/router";
import { environment } from "@env";

export const devEnvGuardFn: CanMatchFn = (_: Route, __: UrlSegment[]) => {
	return !environment.production;
};
